import { useState } from "react";
import { Button, Form, FormFeedback, Input, Label, Spinner } from "reactstrap";
import { EyeOutlined } from "@ant-design/icons";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation } from "react-query";
import { authUser } from "../services/authApi";
import { Link } from "react-router-dom";
import "../utils/log.css";
import ImageLogin from "../../../assets/images/loginImg.png";
import logo from "../../../assets/images/Paxity.png";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { motion } from "framer-motion";

const Login = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);  
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { isLoading, mutate } = useMutation(authUser, {
    onSuccess: (data) => {
      
      if (data?.isAuthorized) {
        setError("");
        if (data.roles.includes("MERCHANT") || data.roles.includes("COLLABORATOR")) {
          if(!data.kycVerified){
            navigate("/new-merchant")
            toast.success(`Bienvenue ${data?.name} dans Paxity`)
          }else {
            navigate("/dashboard");
            console.log('auth response', data)
            toast.success(`${data?.name}! Heureux de vous revoir`)
          }
        } else if (data.roles.includes('ADMIN')) {
          navigate("/dashboard-admin");
          toast.success(`Bonjour admin, sois prudent !`)
        }
      }
    },
    onError: (error) => {
      setError(error || "Erreur de connexion serveur");
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("L'adresse email est incorrect !"),
      password: Yup.string().required("Mot de passe incorrect!"),
    }),
    onSubmit: (values) => {
      if (isSubmitting) return;
      setIsSubmitting(true);
      const { email, password } = validation.values;
      const formData = {
        email: email,
        password: password,
      };
      mutate(formData, {
        onSettled: () => {
          setIsSubmitting(false);
        },
      });
    },
  });

  return (
    <div className="my-box d-flex flex-column flex-lg-row">

      <div className="left-box">
        <img src={ImageLogin} alt="Logo" className="login-image" />
      </div>

      <div className="right-box">
        <div className="py-2 px-md-5">

          <motion.div
            className="mt-0 mb-4"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.5 }}
          >
            <img src={logo} alt="Logo" className="logo h-2 w-15 mb-2" /><br />
          </motion.div>

          <motion.div
            className="mt-4 mb-2 connected"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            Connectez-vous
          </motion.div>

          <motion.div
            className="paragraph-style mt-2 mb-2 texteLogin"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.5 }}
          >
            Prenez le contrôle de vos encaissements en toute simplicité.
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            {error && <div className="alert alert-danger">{error}</div>}

            <Form onSubmit={validation.handleSubmit}>
              <div className="form-group">
                <Label htmlFor="email" className="label">Adresse email</Label>
                <Input
                  name="email"
                  id="email"
                  type="email"
                  value={validation.values.email}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={validation.touched.email && validation.errors.email}
                  className="form-control login-input"
                />
                {validation.touched.email && validation.errors.email && (
                  <FormFeedback>{validation.errors.email}</FormFeedback>
                )}
              </div>

              <div className="form-group">
                <Label htmlFor="password" className="label">Mot de Passe</Label>
                <div className="password-group">
                  <Input
                    autoComplete="on"
                    name="password"
                    id="password"
                    type={passwordShow ? "text" : "password"}
                    value={validation.values.password || ""}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={validation.touched.password && validation.errors.password}
                    className="form-control login-input"
                  />
                  <button
                    type="button"
                    className={`password-toggle-btn ${passwordShow ? "text-primary" : "text-muted"}`}
                    onClick={() => setPasswordShow(!passwordShow)}
                  >
                    <EyeOutlined />
                  </button>
                </div>
                {validation.touched.password && validation.errors.password && (
                  <FormFeedback>{validation.errors.password}</FormFeedback>
                )}

                <div className="mb-2 mt-2">
                  <Link to="/forgot-password" style={{ color: "#2848FF", textAlign: "left" }}>
                    Mot de passe oublié ?
                  </Link>
                </div>
              </div>

              <Button
                disabled={isLoading || isSubmitting || !(validation.isValid && validation.dirty)}
                type="submit"
                style={{ backgroundColor: "#2848FF" }}
                className="login-btn mb-2"
              >
                {isLoading || isSubmitting ? <Spinner size="sm" /> : "Se connecter"}
              </Button>
            </Form>

            <div className="text-center mt-1">
              Vous n'avez toujours pas de compte ?{" "}
              <a href="/register-merchant">S'inscrire</a>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );

};

export default Login;
